var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.schools && _vm.schools.length > 0)?_c('v-container',_vm._l((_vm.schools),function(school,sindex){return _c('x-news',{key:sindex,staticClass:"mx-auto",attrs:{"schoolId":school.id}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }